import { Typography } from "@mui/material";
import LoginStreakRewardsSettings from "./LoginStreakSettings";
import RegistrationRewardsSettings from "./RegistrationRewardsSettings";
import WatchedVideoRewardsSettings from "./WatchedVideoRewardsSettings";

interface SettingsRendererProps {
	settingsType: number;
	rawData: any;
}

export default function SettingsRenderer({ settingsType, rawData }: SettingsRendererProps) {
	switch (settingsType) {
		case 0:
			return <LoginStreakRewardsSettings rawData={rawData} />;
		case 1:
			return <RegistrationRewardsSettings rawData={rawData} />;
		case 2:
			return <WatchedVideoRewardsSettings rawData={rawData} />;
		default:
			return <Typography variant="body2">Unknown settings type</Typography>;
	}
}
